const React = require("react");
const Layout = require("./src/components/Layout").default;

exports.wrapPageElement = ({ element, props }) => <Layout {...props}>{element}</Layout>;
exports.shouldUpdateScroll = ({ prevRouterProps, routerProps }) => prevRouterProps !== routerProps;
